import type {
  ShipmentFormulationType,
  InvoiceDetailsType,
} from 'jsx/dashboard/models/shipmentModel';
import SubscriptionItemModel, {
  SubscriptionItemData,
} from 'jsx/models/subscriptionItem';

export interface UpcomingShipmentData {
  shipmentItems: SubscriptionItemData[];
  shipsOnDate: string | null;
  estimatedDeliveryDate: string | null;
  paymentDetails: InvoiceDetailsType;
  earliestRescheduleDate: string | null;
  latestRescheduleDate: string | null;
  formulations?: ShipmentFormulationType[] | null;
}
export class UpcomingShipmentModel {
  constructor(data: UpcomingShipmentData) {
    this.shipmentItems = data.shipmentItems.map(
      (item) => new SubscriptionItemModel(item),
    );
    this.shipsOnDate = data.shipsOnDate;
    this.estimatedDeliveryDate = data.estimatedDeliveryDate;
    this.paymentDetails = data.paymentDetails;
    this.earliestRescheduleDate = data.earliestRescheduleDate;
    this.latestRescheduleDate = data.latestRescheduleDate;
    this.formulations = data.formulations;
  }

  readonly shipmentItems: SubscriptionItemModel[];

  readonly shipsOnDate: string | null;

  readonly estimatedDeliveryDate: string | null;

  readonly paymentDetails: InvoiceDetailsType;

  readonly earliestRescheduleDate: string | null;

  readonly latestRescheduleDate: string | null;

  readonly formulations?: ShipmentFormulationType[] | null;
}
